import { FC, useEffect } from "react";
import { isValidMongoId } from "@/utils/common";
import { useRouter } from "next/router";
import { useSearchParams } from "next/navigation";
import { ItalianStoryResponseTo } from "../../../models/italianStory";
import HeadSection from "../../common/HeadSection";
import ItalianStories from "../../home/ItalianStories";
import ItalianStoryArticle from "./ItalianStoryArticle";
import {
    relatedArticlesSubTitle,
    relatedArticlesTitle,
} from "../../../utils/mockData/italianStoriesMocks";
import Brochures from "../../home/brochures/Brochures";
import { useShouldRenderArrayFC } from "../../../utils/hooks/useShouldRenderArrayFC";
import ItalianTourSingleType from "../../home/italianTour/ItalianTourSingleType";

const ItalianStoryBody: FC<{
    italianStory: ItalianStoryResponseTo;
}> = ({ italianStory }) => {
    const { coverImage, associatedBlogs, tours } = italianStory;

    const searchParams = useSearchParams();
    const router = useRouter();

    const headData = {
        backgroundImageUrl: coverImage,
        title: [
            {
                text: "Italian Stories",
                color: "",
                fontWeight: "fw-bold",
                newLine: true,
            },
        ],
        subTitle: [],
    };

    useEffect(() => {
        // se si sta navigando verso l'italian story per id, eseguiamo il redirect verso la navigazione per titolo
        if (isValidMongoId(searchParams.getAll("slug")[0] ?? "")) {
            router.push({
                pathname: "/italian-stories/[slug]",
                query: {
                    slug: italianStory.internalName,
                },
            });
        }
    }, []);

    return (
        <div className="minWidth100vwFromXL">
            <HeadSection className="mb-2" content={headData} />
            <ItalianStoryArticle italianStory={italianStory} />
            {useShouldRenderArrayFC(tours) && (
                <ItalianTourSingleType content={tours!} />
            )}
            {useShouldRenderArrayFC(associatedBlogs) && (
                <ItalianStories
                    sectionTitle={relatedArticlesTitle}
                    sectionSubTitle={relatedArticlesSubTitle}
                    content={associatedBlogs!}
                />
            )}
            <Brochures />
        </div>
    );
};

export default ItalianStoryBody;
